<!-- =========================================================================================
  File Name: FormWizardValidation.vue
  Description: Form wizard with validation
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <vx-card title v-show="step1">
      <div class="mt-5">
        <div class="vx-row">
          <div class="vx-col md:w-1/1 w-full mt-5">
            <h6 class="mb-2">Cliente</h6>
            <v-select
              name="customer"
              v-model="customerSelected"
              :options="getCustomersFiltered"
              :loading="isLoadingCustomers"
              :filterable="true"
              :searchable="true"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-validate="'required'"
              placeholder="Digite para buscar (min. 2 caracteres)..."
              @search="onSearchCustomers"
              :no-drop="searchTerm.length > 0 && searchTerm.length < 2"
              :close-on-select="true"
            >
              <template slot="no-options">
                <span v-if="searchTerm.length > 0 && searchTerm.length < 2">
                  Digite pelo menos 2 caracteres
                </span>
                <span v-else-if="isLoadingCustomers"> Carregando... </span>
                <span v-else> Nenhum cliente encontrado </span>
              </template>
            </v-select>
            <span class="text-danger">{{ errors.first("customer") }}</span>
          </div>
        </div>
        <br />
        <div class="vx-row" v-show="customerSelected.id">
          <div class="vx-col md:w-1/1 w-full mt-5">
            <h6 class="mb-2">Endereço: {{ customerSelected.address }}</h6>
            <h6 class="mb-2">Bairro: {{ customerSelected.district }}</h6>
            <h6 class="mb-2">
              Cidade: {{ customerSelected.city }} CEP:
              {{ customerSelected.cep }}
            </h6>
            <h6 class="mb-2" v-show="customerSelected.cnpj">
              CNPJ: {{ customerSelected.cnpj }}
            </h6>
            <h6 class="mb-2" v-show="customerSelected.cpf">
              CPF: {{ customerSelected.cpf }}
            </h6>
            <h6 class="mb-2">
              Inscrição Estadual: {{ customerSelected.stateRegistration }}
            </h6>
            <h6 class="mb-2">Email: {{ customerSelected.mail }}</h6>
            <h6 class="mb-2">Telefone: {{ customerSelected.phone }}</h6>
            <h6 class="mb-2">Ilux: {{ customerSelected.idIlux }}</h6>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-3/4 mt-5"></div>
          <div class="vx-col md:w-1/4 mt-1" align="right">
            <vs-button
              color="success"
              type="border"
              icon-pack="feather"
              icon="icon-plus"
              @click="addNewData"
            ></vs-button>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/3 w-full mt-5">
            <h6 class="mb-2">Tipo de Pedido</h6>
          </div>
          <div class="vx-col md:w-1/3 w-full mt-5">
            <h6 class="mb-2">Tipo de Contrato</h6>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/3 w-full mt-5">
            <ul class="demo-alignment">
              <li>
                <vs-radio color="#1E90FF" v-model="orderType" vs-value="Locação"
                  >Locacão</vs-radio
                >
              </li>
            </ul>
          </div>
          <div class="vx-col md:w-1/3 w-full mt-5">
            <ul class="demo-alignment">
              <li>
                <vs-radio
                  color="success"
                  v-model="contractType"
                  vs-value="Novo Contrato"
                  >Novo Contrato</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  color="primary"
                  v-model="contractType"
                  vs-value="Adendo"
                  >Adendo</vs-radio
                >
              </li>
            </ul>
          </div>
        </div>
        <br />
        <br />
        <div class="vx-row">
          <div class="vx-col md:w-1/3 w-full mt-5">
            <h6 class="mb-2">Data</h6>
            <!--<vs-input id="date" type="datetime-local" v-model="date"  />-->
            <div>
              <datepicker
                placeholder="Selecione a Data"
                :language="languages['ptBR']"
                format="dd/MM/yyyy"
                v-model="date"
              ></datepicker>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-1/2 mt-5">
            <h6 class="mb-2">Nome do Responsável</h6>
            <vs-input v-model="personName" class="w-full" />
          </div>
          <div class="vx-col md:w-1/2 w-1/2 mt-5">
            <h6 class="mb-2">Cargo</h6>
            <vs-input v-model="personRole" class="w-full" />
          </div>
        </div>
        <div class="vx-row">
          <div
            class="vx-col md:w-1/2 w-full mt-5"
            v-if="this.$store.state.user.userGroup == 'admin'"
          >
            <h6 class="mb-2">Consultor</h6>
            <v-select
              name="user"
              v-model="userSelected"
              :options="getUsers"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-validate="'required'"
            />
            <span class="text-danger">{{ errors.first("step-1.user") }}</span>
          </div>
          <div class="vx-col md:w-1/2 w-1/2 mt-5">
            <h6 class="mb-2">Meses de Contrato</h6>
            <vs-input v-model="contractMonths" class="w-full" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-1/2 mt-5">
            <h6 class="mb-2">Observação</h6>
            <vs-input v-model="generalObservation" class="w-full" />
          </div>
        </div>
        <AddNewCustomer
          :isSidebarActive="addNewDataSidebar"
          @closeSidebar="toggleDataSidebar"
          :data="sidebarData"
        />

        <vs-button class="float-right" @click="goStep2">Próximo</vs-button>
        <br />
        <br />
      </div>
    </vx-card>
    <vx-card v-show="step2">
      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-full">
          <div class="mt-5">
            <TableProducts
              :data="productsSelected"
              v-on:selectProducts="selectProducts"
              :orderType="orderType"
              text="Pedido"
            />
            <vs-button class="float-left" @click="goStep1">Voltar</vs-button>
            <vs-button class="float-right" @click="goStep3">Próximo</vs-button>
            <br />
            <br />
          </div>
        </div>
      </div>
    </vx-card>
    <vx-card v-show="step3">
      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-full">
          <div class="mt-5">
            <TableContracts :idOrder="idOrder" />
            <vs-button class="float-left" @click="goStep2">Voltar</vs-button>
            <vs-button class="float-right" @click="submit">Salvar</vs-button>
            <br />
            <br />
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>



<script>
import TableProducts from "../orderProducts/component/EditTableLease.vue";
import TableContracts from "../orderProducts/TableContractsLease.vue";
import AddNewCustomer from "../customers/AddNewCustomer";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import { momentJS, numberJS } from "@/helpers";
import { Validator } from "vee-validate";
import { baseApiUrl } from "@/global";
import router from "@/router";
import axios from "axios";
const dict = {
  custom: {
    customer: {
      required: "Selecione o cliente",
    },
    user: {
      required: "Selecione o Consultor",
    },
  },
};

Validator.localize("en", dict);
export default {
  components: {
    "v-select": vSelect,
    AddNewCustomer,
    TableProducts,
    TableContracts,
    Datepicker,
  },
  computed: {
    // Computed otimizado - agora pega direto do state
    getCustomersFiltered() {
      return this.$store.state.customers.customersFiltered || [];
    },

    // Novo computed para verificar loading
    isLoadingCustomers() {
      return this.$store.state.customers.isLoading;
    },
    getUsers() {
      return this.$store.state.usersFiltered;
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.products.length;
    },
    getProducts() {
      return this.$store.state.products;
    },
  },
  data() {
    return {
      step1: true,
      step2: false,
      step3: false,
      idOrder: "",
      customerSelected: [],
      orderType: null,
      contractType: null,
      generalObservation: null,
      itemsPerPage: 100,
      products: [],
      personName: "",
      personRole: "",
      productsSelected: [],
      userSelected: null,
      date: null,
      languages: lang,
      addNewDataSidebar: false,
      sidebarData: {},
      terms: "",
      contractMonths: null,
      // Novos dados para otimização
      searchTerm: "",
      maxResults: 50,
      minSearchLength: 2,
    };
  },
  methods: {
    onSearchCustomers: _.debounce(async function (search) {
      this.searchTerm = search || "";

      try {
        await this.$store.dispatch("customers/searchCustomers", {
          searchTerm: this.searchTerm,
          limit: this.maxResults,
        });
      } catch (error) {
        console.error("Erro na busca de clientes:", error);
        this.$vs.notify({
          title: "Erro",
          text: "Erro ao buscar clientes. Tentando busca local...",
          color: "warning",
        });
      }
    }, 300),

    // Método para pré-carregar dados essenciais
    async preloadCustomersData() {
      try {
        const payload = {
          loading: this.$vs.loading,
          idOrder: null,
          typeOrder: this.endpointType,
          idCustomer: this.customerSelected.id,
        };

        // Carregar todos os clientes uma vez
        await this.$store.dispatch("customers/fetchCustomersItems", payload);

        // Aplicar busca inicial vazia para mostrar primeiros resultados
        await this.$store.dispatch("customers/searchCustomers", {
          searchTerm: "",
          limit: this.maxResults,
        });
      } catch (error) {
        console.error("Erro ao pré-carregar clientes:", error);
        this.$vs.notify({
          title: "Aviso",
          text: "Erro ao carregar lista de clientes",
          color: "warning",
        });
      }
    },
    goStep1() {
      this.step1 = true;
      this.step2 = false;
      this.step3 = false;
    },
    async goStep2() {
      const haveErrors = !(await this.$validator.validateAll());
      console.log(haveErrors);
      if (haveErrors) return;
      this.step1 = false;
      this.step2 = true;
      this.step3 = false;
    },
    async goStep3() {
      this.step1 = false;
      this.step2 = false;
      this.step3 = true;
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    selectProducts(products) {
      this.productsSelected = products;
    },
    submit() {
      let fk_idUser;
      if (this.$store.state.user.userGroup == "admin") {
        fk_idUser = this.userSelected.id;
      } else {
        fk_idUser = this.$store.state.user.idUser;
      }
      let payload = {
        order: {
          fk_idCustomer: this.customerSelected.id,
          orderType: this.orderType,
          contractType: this.contractType,
          fk_idUser: fk_idUser,
          idOrder: this.idOrder,
          itemsOrder: this.productsSelected,
          dateOrder: momentJS().formatDateTime(this.date),
          totalOrder: numberJS().totalOrder(this.productsSelected),
          personName: this.personName,
          personRole: this.personRole,
          contractMonths: this.contractMonths,
          generalObservation: this.generalObservation,
        },
        notify: this.$vs.notify,
        loading: this.$vs.loading,
      };
      if(payload.order.fk_idCustomer == null || payload.order.fk_idCustomer == undefined) {
        this.$vs.notify({
          title: "Atenção",
          text: "Selecione um cliente",
          color: "warning",
        });
        return;
      }
      this.$store.dispatch("lease/updateLeaseOrder", payload);
    },
  },

  async created() {
     // Pré-carregar dados otimizado
     await this.preloadCustomersData()
    try {
      this.$vs.loading();
      const response = await axios.get(
        `${baseApiUrl}/leaseOrder/getLeaseOrderById/${this.$route.params.idOrder}`
      );
      this.$vs.loading.close();
      this.date = response.data.order[0].dateOrder;
      this.idOrder = response.data.order[0].idOrder;
      this.personName = response.data.order[0].personName;
      this.personRole = response.data.order[0].personRole;
      this.orderType = response.data.order[0].orderType;
      this.contractType = response.data.order[0].contractType;
      this.generalObservation = response.data.order[0].generalObservation;
      this.contractMonths = response.data.order[0].contractMonths;
      let user = {
        id: response.data.order[0].idUser,
        label: response.data.order[0].userName,
        name: response.data.order[0].userName,
      };
      let customer = {
        id: response.data.order[0].idCustomer,
        label: response.data.order[0].corporateName,
        corporateName: response.data.order[0].corporateName,
        address: response.data.order[0].address,
        district: response.data.order[0].district,
        city: response.data.order[0].city,
        cnpj: response.data.order[0].cnpj,
        cpf: response.data.order[0].cpf,
        stateRegistration: response.data.order[0].stateRegistration,
        mail: response.data.order[0].mail,
        phone: response.data.order[0].phone,
        idIlux: response.data.order[0].idIlux,
      };
      this.userSelected = user;
      this.customerSelected = customer;

      for (let product of response.data.products) {
        let obj = {
          idProduct: product.idProduct,
          name: product.name,
          code: product.code,
          category: product.category,
          valueClicPB: product.valueClicPB,
          valueClicColor: product.valueClicColor,
          pageFranchise: product.pageFranchise,
          pageFranchiseColor: product.pageFranchiseColor,
          franchiseValue: product.franchiseValue,
          surplusValue: product.surplusValue,
          surplusValueColor: product.surplusValueColor,
          amount: product.amount,
          rate: product.rate,
        };

        this.productsSelected.push(obj);
      }
    } catch (error) {
      console.log(error);

      this.$vs.notify({
        title: "Erro",
        text: "Não foi possivel carregar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
      });

      if (error.response.status == "400") {
        router.push(`/locacao`).catch(() => {});
      }
    }

    let payload = {
      loading: this.$vs.loading,
    };

    //this.$store.dispatch("customers/fetchCustomersItems", payload);
    this.$store.dispatch("fetchProductsItems", payload);
    this.$store.dispatch("fetchAllUsers", payload);

    setInterval(() => {
      this.$store.dispatch('customers/clearExpiredCache')
    }, 5 * 60 * 1000) // A cada 5 minutos
  },

  // Limpar intervalos ao destruir componente
  beforeDestroy() {
    // Limpar qualquer timer se necessário
  }
};
</script>
